import PropTypes from 'prop-types';
import "./CampaignAnalytics.scss";
import { convertMSToHMS, getLongDateString } from "../../helpers/Dates";
import { IconJsxer } from '../../helpers/IconHelper';
import HeadedPanel from '../HeadedPanel/HeadedPanel';
import LeftColorBlockBox from '../LeftColorBlockBox/LeftColorBlockBox';

/*
    If you want to restyle this, override the css!
*/
const CampaignAnalytics = (props) => {

    let dataObj = {
        numberOfStreams:0,
        totalInteractions:0,
        uniqueUsers:0,
        peakViewers: 0,
        engagementTime:0,
        totalRunTime:0,
        firstStreamTime:0,
        firstStreamEndTime:0,
        featuresRun:0,
        disruptorsPlayed:0,
        botsPosted:0,
        totalMessages:0,
    }
    props._campaignAnalyticsSummary.forEach((campaignSummary) =>{
        let includedStreamInOverall = false;
        campaignSummary.recordedAnalytics.forEach((individualStreamData) => {
            if(!individualStreamData.disabled)
            {
                if(!includedStreamInOverall) 
                {
                    dataObj.numberOfStreams ++;
                    includedStreamInOverall = true;
                }

                if(dataObj.firstStreamTime == 0 || dataObj.firstStreamTime > individualStreamData.featureStartTime )  
                {
                    dataObj.firstStreamTime = individualStreamData.featureStartTime      
                    dataObj.firstStreamEndTime = individualStreamData.featureStartTime +  individualStreamData.featureRunTime 
                } 
                dataObj.uniqueUsers += individualStreamData.uniqueUsers;
                dataObj.totalInteractions += individualStreamData.interactions;
                dataObj.totalMessages += individualStreamData.messages || 0;
                dataObj.engagementTime += individualStreamData.engagementTime;
                dataObj.totalRunTime += individualStreamData.featureRunTime;
                if (individualStreamData.peakViewers > dataObj.peakViewers) {
                    dataObj.peakViewers = individualStreamData.peakViewers;
                }
                dataObj.featuresRun += individualStreamData.featuresRun || 0;
                dataObj.disruptorsPlayed += individualStreamData.disruptorsFired || 0;
                dataObj.botsPosted += individualStreamData.botsPosted || 0;
            }
            //datatObj.campaignData.push(individualStreamData);
        })
        
    })

    const startTimeStr = convertMSToHMS(dataObj.firstStreamTime);
    const endTimeStr = convertMSToHMS(dataObj.firstStreamTime + dataObj.totalRunTime);
    const firstStreamTotalTimeStr = convertMSToHMS(dataObj.firstStreamEndTime - dataObj.firstStreamTime);
    const engagementTimeStr = convertMSToHMS(dataObj.engagementTime);
    const totalRunTimeStr = convertMSToHMS(dataObj.totalRunTime);
    
    return (
        <>
            <div className="analytics-campaign-entry">
                <div className="analytics-campaign-title">
                    <h5>{props._campaignName}</h5>
                </div>
                <div className='analytics-info-item analytics-client-name'>
                    {props._client}
                </div>

                <div className={`analytics-summary-panel no-panel-shadow${props._clickable ? ' button-active' : ''}`} onClick={props._clickable ? (e) => {e.preventDefault(); props._openAnalyticsOverview(e, props._campaignId);} : null}>
                    <div className="analytics-container">

                        {/* Left: Client + Stream Details */}
                        <div className='analytics-info-row'>

                            <div className='analytics-info-item'>
                                <div>{IconJsxer.GetIcon(IconJsxer.ICONS.scheduleNav, IconJsxer.ICON_STYLES.standardW)}</div>
                                <div>{getLongDateString(dataObj.firstStreamTime)}</div>
                            </div>
                            <div className='analytics-info-item'>
                                <div>{IconJsxer.GetIcon(IconJsxer.ICONS.liveStream, IconJsxer.ICON_STYLES.standardW)}</div>
                                <div>Streams: {dataObj.numberOfStreams}/{props._numberOfStreams}</div>
                            </div>
                            <div className='analytics-info-item'>
                                <div>{IconJsxer.GetIcon(IconJsxer.ICONS.eye, IconJsxer.ICON_STYLES.standardW)}</div>
                                <div>Peak Viewers: {dataObj.peakViewers.toLocaleString()}</div>
                            </div>
                            <div className='analytics-info-item'>
                                <div>{IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.standardW)}</div>
                                <div>Total Runtime: {totalRunTimeStr.h+':'+totalRunTimeStr.m_str+':'+totalRunTimeStr.s_str}</div>
                            </div>
                        </div>

                        <div className={`analytics-grid analytics-grid--${props._gridLayout || '2-columns'}`}>
                            <LeftColorBlockBox style="an_brand_engagement" className="analytics-grid-box">
                                <div className='analytics-summary-content'>
                                    <div>Feature Engagement</div>
                                    <h5>{engagementTimeStr.h+':'+engagementTimeStr.m_str+':'+engagementTimeStr.s_str}</h5>
                                </div>
                            </LeftColorBlockBox>

                            <LeftColorBlockBox style="an_total_interactions" className="analytics-grid-box">
                                <div className='analytics-summary-content'>
                                    <div>Total Interactions</div>
                                    <h5>{dataObj.totalInteractions.toLocaleString()}</h5>
                                </div>
                            </LeftColorBlockBox>

                            <LeftColorBlockBox style="an_u_users" className="analytics-grid-box">
                                <div className='analytics-summary-content'>
                                    <div>Unique Users</div>
                                    <h5>{dataObj.uniqueUsers.toLocaleString()}</h5>
                                </div>
                            </LeftColorBlockBox>

                            <LeftColorBlockBox style="an_messages" className="analytics-grid-box">
                                <div className='analytics-summary-content'>
                                    <div>Messages</div>
                                    <h5>{dataObj.totalMessages.toLocaleString()}</h5>
                                </div>
                            </LeftColorBlockBox>

                            <LeftColorBlockBox style="feature_default" className="analytics-grid-box">
                                <div className='analytics-summary-content'>
                                    <div>Features Ran</div>
                                    <h5>{dataObj.featuresRun}</h5>
                                </div>
                            </LeftColorBlockBox>

                            <LeftColorBlockBox style="bot_default" className="analytics-grid-box">
                                <div className='analytics-summary-content'>
                                    <div>Bot Posts</div>
                                    <h5>{dataObj.botsPosted}</h5>
                                </div>
                            </LeftColorBlockBox>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default CampaignAnalytics;